import type { GitHubService } from './GitHubService';
import { buildDefaultNewsFeedPreferences } from '../utils/newsFeedDefaults';
import { parseNewsFeedConfigJson } from '../utils/parseNewsFeedConfig';
import { setNewsFeedPreferences } from '../utils/newsFeedConfigState';
import type { NewsFeedPreferences } from '../utils/newsFeedDefaults';

export const NEWS_FEED_CONFIG_PATH = 'database/.news-feed.json';

export class NewsFeedConfigService {
  private prefs: NewsFeedPreferences = buildDefaultNewsFeedPreferences();

  constructor(private readonly github: GitHubService) {}

  getPreferences(): NewsFeedPreferences {
    return this.prefs;
  }

  async load(): Promise<void> {
    try {
      const { content } = await this.github.readFile(NEWS_FEED_CONFIG_PATH);
      this.prefs = parseNewsFeedConfigJson(content);
    } catch {
      this.prefs = buildDefaultNewsFeedPreferences();
    }
    setNewsFeedPreferences(this.prefs);
  }
}
